import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Unauthorized from "../../pages/Auth/Unauthorized";
import {
  APP_SETTINGS_EVENT,
  getCachedAppSettings,
  getAppSettings,
} from "../../services/appSettingsService";
import { canAccessItem } from "../../services/accessControl";
import { isAuthenticated } from "../../services/authService";
import Spinner from "../ui/Spinner";
import styles from "./ProtectedRoute.module.css";

const ProtectedRoute = ({ children, access }) => {
  const location = useLocation();
  const [settings, setSettings] = useState(() => getCachedAppSettings());
  const [loading, setLoading] = useState(() => !getCachedAppSettings());

  useEffect(() => {
    let isMounted = true;

    const loadSettings = async () => {
      if (getCachedAppSettings()) {
        if (isMounted) {
          setSettings(getCachedAppSettings());
          setLoading(false);
        }
        return;
      }

      const nextSettings = await getAppSettings();

      if (isMounted) {
        setSettings(nextSettings);
        setLoading(false);
      }
    };

    loadSettings();
    window.addEventListener(APP_SETTINGS_EVENT, loadSettings);

    return () => {
      isMounted = false;
      window.removeEventListener(APP_SETTINGS_EVENT, loadSettings);
    };
  }, []);

  if (!isAuthenticated()) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (loading || !settings) {
    return (
      <div className={styles.loading}>
        <Spinner />
      </div>
    );
  }

  if (!canAccessItem(access, settings)) {
    return <Unauthorized />;
  }

  return children;
};

export default ProtectedRoute;
